"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicProductStock = exports.getPublicProductStocks = exports.putProductStockAccessibility = exports.deleteProductStockPermission = exports.postProductStockPermission = exports.postProductStock = exports.putProductStock = exports.getProductStock = exports.getProductStocks = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var productStocksAuthorizedPath = root_1.ecommerceAuthorized + '/productstocks/';
var productStocksPublicPath = root_1.ecommercePublic + '/productstocks/';

var getProductStocks = function getProductStocks(authentication, queryParameters) {
  return common_1.get(authentication, productStocksAuthorizedPath, queryParameters);
};

exports.getProductStocks = getProductStocks;

var getProductStock = function getProductStock(authentication, id) {
  return common_1.get(authentication, productStocksAuthorizedPath + id);
};

exports.getProductStock = getProductStock;

var putProductStock = function putProductStock(authentication, productstock) {
  return common_1.put(authentication, productStocksAuthorizedPath + productstock.id, productstock);
};

exports.putProductStock = putProductStock;

var postProductStock = function postProductStock(authentication, productstock) {
  return common_1.post(authentication, productStocksAuthorizedPath, productstock);
};

exports.postProductStock = postProductStock;

var postProductStockPermission = function postProductStockPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, productStocksAuthorizedPath, id, permission);
};

exports.postProductStockPermission = postProductStockPermission;

var deleteProductStockPermission = function deleteProductStockPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, productStocksAuthorizedPath, id, permissionId);
};

exports.deleteProductStockPermission = deleteProductStockPermission;

var putProductStockAccessibility = function putProductStockAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, productStocksAuthorizedPath, id, accessibility);
};

exports.putProductStockAccessibility = putProductStockAccessibility;

var getPublicProductStocks = function getPublicProductStocks(authentication, queryParameters) {
  return common_1.get(authentication, productStocksPublicPath, queryParameters);
};

exports.getPublicProductStocks = getPublicProductStocks;

var getPublicProductStock = function getPublicProductStock(authentication, id) {
  return common_1.get(authentication, productStocksPublicPath + id);
};

exports.getPublicProductStock = getPublicProductStock;